import { AccessPolicyValue } from "app/area/external-url-groups/form/types-store";
import { ComplexValue } from "app/types-shared";

export const createInitialAccessPolicy = (id: number) => ({
  id,
  caseType: undefined,
  operation: undefined
} as AccessPolicyValue);

export const createId = (value: AccessPolicyValue[]) => value.length > 0 ? Math.max(...value.map(item => item.id)) + 1 : 1;

export const getOnlyExistedValues = (value: ComplexValue<number>) => !!value && JSON.parse(JSON.stringify(value));
